import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { App } from './App.js';

/**
 * Dashboard entrypoint.
 *
 * The application is a static single-page build. It holds no server-rendered state and no token:
 * the session lives in an HttpOnly cookie the browser attaches to same-origin `/api` calls.
 */
const container = document.getElementById('root');
if (!container) {
  throw new Error('Dashboard root element is missing.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
